export default __webpack_public_path__ + "static/media/OutdoorSeating1.c74bf3ec.webp";